<template>
	<span>{{display}}</span>
</template>

<script>
var tokens = {
	'#': {pattern: /\d/},
	'X': {pattern: /[0-9a-zA-Z]/},
	'S': {pattern: /[a-zA-Z]/},
	'A': {pattern: /[a-zA-Z]/, transform: v => v.toLocaleUpperCase()},
	'a': {pattern: /[a-zA-Z]/, transform: v => v.toLocaleLowerCase()},
	'!': {escape: true}
}
import masker from './masker'

export default {
  name: 'TheMask',
  props: {
    value: [String, Number],
    mask: {
      type: [String, Array],
      required: true
    },
    masked: { // by default emits the value unformatted, change to true to format with the mask
      type: Boolean,
      default: true // raw
    },
    tokens: {
      type: Object,
      default: () => tokens
    }
  },
  data () {
    return {
      lastValue: null, // avoid unecessary emit when has no change
      display: this.value
    }
  },
  watch : {
    value (newValue) {
      if (newValue !== this.lastValue) {
      	this.refresh(newValue)
      }
    },
    masked () {
      this.refresh(this.display)
    }
  },
  computed: {
    config () {
      return {
        mask: this.mask,
        tokens: this.tokens,
        masked: this.masked
      }
    }
  },
  methods: {
    refresh (value) {
	  this.display = masker(value, this.mask, this.masked, this.tokens)
    }
  }
}
</script>
